import {inject, IReactComponent} from 'mobx-react';
import {VideoComponent} from './VideoComponent';

function mapStoresToProps(stores: any) {
    return {
        controller: stores.multipartyDashboardStore.videoController
    };
}

export const Video = inject(mapStoresToProps)(VideoComponent) as IReactComponent;
